import LinkRenderer from "./LinkRenderer"
import Link from "./Link"
import Quote from "./Quote"
import Icon from "./Icon"
import Video from "./Video"

import Block from "./Block"
import Endowments from "./Endowments"
import Intro from "./Intro"
import IntroSection from "./IntroSection"

const fieldRenderer = {
    Block,
    LinkRenderer,
    Link,
    Icon,
    Quote,

    video: Video,
    Endowments,
    Intro,
    IntroSection,
}
export default fieldRenderer

//export { Link, Quote, Icon, Video, Block, Level, ContactData, Map, Events, Form, Grade }
